import { getFormIdField } from 'chameleon-src/components/assign/AssignManageForm/utils';

const getFormAndDisabledStudentsById = (props, callback) => {
  const { subjectClasses, assignments } = props;
  let disabledStudents = [];

  assignments.forEach((assignmentData) => {
    const { currentIsa, studentIdsFromOtherIsa } = assignmentData;

    const {
      assignmentId: currentIsaAssignmentId,
      sectionId: assigneeId,
      studentIds: assigneeStudentIds,
    } = currentIsa;
    const section = subjectClasses.find((s) => s.id === currentIsa.sectionId);

    if (assigneeStudentIds.length === 0) {
      disabledStudents = disabledStudents.concat(
        section.students.map((sectionStudent) => ({
          ...sectionStudent,
          id: getFormIdField(
            sectionStudent.id,
            assigneeId,
            currentIsaAssignmentId,
          ),
          studentId: sectionStudent.id,
          sectionId: assigneeId,
          assignmentId: currentIsaAssignmentId,
        })),
      );
    } else {
      section.students.forEach((sectionStudent) => {
        const { id: studentId } = sectionStudent;
        const studentInFormFormat = {
          ...sectionStudent,
          id: getFormIdField(studentId, assigneeId, currentIsaAssignmentId),
          studentId,
          sectionId: assigneeId,
          assignmentId: currentIsaAssignmentId,
        };

        if (assigneeStudentIds.includes(studentId)) {
          disabledStudents.push(studentInFormFormat);
        } else if (studentIdsFromOtherIsa.includes(studentId)) {
          disabledStudents.push({
            ...studentInFormFormat,
            fromOtherISA: true,
          });
        }
      });
    }
  });

  if (callback) {
    callback(disabledStudents);
  } else {
    return disabledStudents;
  }
};

export default getFormAndDisabledStudentsById;
